export enum CustomerScope {
    Troman = 0,
    Valman = 1,
}

export enum DetailVariant {
    None = 0,
    Full = 1,
    Limited = 2,
}

export enum PermissionMode {
    None = 0,
    ReadAll = 2,
    WriteLimited = 4,
    WriteAll = 8,
}

export enum InitLoginResult {
    Undecided = 0,
    SSO = 1,
    Failed = 3,
}

export enum RoleMode {
    None = 0,
    Full = 1,
    Detailed = 3,
}

export enum SSOLoginType {
    Regular = 0,
    Auto = 1,
}

